import React from 'react';
import { useTranslation } from 'react-i18next';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import ChevronDown from '@/icons/ChevronDown';

export interface SpouseInfo {
  id: string;
  displayName: string;
}

interface SpouseSwitcherProps {
  familyMemberId: string;
  spouses: SpouseInfo[];
  currentSpouseFamilyMemberId: string | null;
  onSpouseSelect: (spouseFamilyMemberId: string) => void;
}

/**
 * Pill control for switching between multiple spouses (design v0.1 — matches mock pcard__spouse-dd).
 */
export const SpouseSwitcher: React.FC<SpouseSwitcherProps> = ({
  spouses,
  currentSpouseFamilyMemberId,
  onSpouseSelect
}) => {
  const { t } = useTranslation('forms');

  if (spouses.length <= 1) {
    return null;
  }

  const switchLabel = t('person.switchSpouse');

  return (
    <DropdownMenu.Root>
      <div className="spouse-switcher">
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            className="spouse-switcher-toggle"
            title={switchLabel}
            aria-label={switchLabel}
            onClick={(e) => e.stopPropagation()}
          >
            {t('person.spousesCount', { count: spouses.length })}
            <ChevronDown width={10} height={10} className="spouse-switcher-caret" aria-hidden />
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content
            className="spouse-switcher-dropdown"
            side="bottom"
            align="start"
            sideOffset={4}
            onClick={(e) => e.stopPropagation()}
          >
            <DropdownMenu.RadioGroup value={currentSpouseFamilyMemberId ?? ''} onValueChange={onSpouseSelect}>
              {spouses.map((spouse) => (
                <DropdownMenu.RadioItem key={spouse.id} className="spouse-option" value={spouse.id}>
                  {spouse.displayName}
                </DropdownMenu.RadioItem>
              ))}
            </DropdownMenu.RadioGroup>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </div>
    </DropdownMenu.Root>
  );
};
